import { environment } from '@environments/environment';

export class ProgramApplicationFormConstant {
  public static programs = environment.serverUri + `api/${environment.apiVersion}/programs`;

  public static form = {
    detail: (programId: string, applicationId: string, formId: string) => {
      return `${ProgramApplicationFormConstant.programs}/${programId}/applications/${applicationId}/forms/${formId}`;
    },
    updateComment: (programId: string, applicationId: string) => {
      return `${ProgramApplicationFormConstant.programs}/${programId}/applications/${applicationId}`;
    },
  };
}

